module.exports = __webpack_public_path__ + "static/img/13.5112866.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/13.png
// module id = dLvX
// module chunks = 0